import { BehaviorBuilder } from '@eab-aip/ai-behavior-builder/ai-behavior-builder';
import { AsLitHIC, BehaviorElement, HIP } from '@eab-eip/hi-hip/hi-hif';
import { LitElement } from 'lit-element';
import { html, render } from 'lit-html';

import f1 from '@eab-pip/pi-f1';

import { createPanelEl } from './ai-visitor-dashboard-panel';

import './ai-visitor-dashboard-chart';
import './ai-visitor-dashboard-table';
import './ai-visitor-dashboard-metric';

/**
 * @customElement
 * @polymer
 * @appliesMixin BehaviorElement
 * @appliesMixin BehaviorBuilder
 */
export class BuilderDashboardElement extends BehaviorBuilder(BehaviorElement(AsLitHIC(LitElement))) {
  static get is() {
    return 'ai-builder-dashboard';
  }

  static get properties() {
    return {
      report: {
        type: Object
      }
    };
  }

  createRenderRoot() {
    return this;
  }

  renderPanel(fieldType: Object) {
    return html`${createPanelEl(fieldType, this)}`;
  }

  renderDashboard(fields: any[]) {
    const hrf = !f1.is.empty(f1.read(f1.lens(`/report/render/panel`), {}, this))
      ? f1.read(f1.lens(`/report/render/panel`), {}, this)
      : f1.read(f1.lens(`/report/panel`), {}, this);

    const layout = f1.read(f1.lens(`/render/render_type`), {}, hrf);
    const column = f1.read(f1.lens(`/render/render_columns`), {}, hrf);

    return html`
      <vi-dashboard
        id="_visualization_chart"
        gid="_visualization_chart"
        ns="${this.ns}"
        layout="${layout}"
        column="${column}"
      >
        ${(fields || []).map((fieldType) => this.renderPanel(fieldType))}
      </vi-dashboard>
    `;
  }

  updated() {
    const properties = f1.read(f1.lens('/input/properties'), {}, this);
    const fields = f1.values(properties);
    render(this.renderDashboard(fields), this);
  }
}

HIP.factory.element(BuilderDashboardElement);
export default 'ai-builder-dasboard';
